module.exports = __webpack_public_path__ + "static/media/upload.0c5ecd85.svg";